import { Platform } from 'react-native';
import {
  JDShare
} from '@jdreact/jdreact-core-lib';

export const jdAppShare = (shareInfo) => {
  const { url, title, content, channel } = shareInfo;
  if (Platform.OS === 'web') {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('jdapp') >= 0 && typeof JdShare !== 'undefined') {
      JdShare.setShareInfo({
        title: title,
        content: content,
        url: url,
        img: 'https://misc.360buyimg.com/business/house/static/img/sharelogo.png',
        channel: channel,
        callback: null,
        clickcallback: null,
        qrparam: null,
        timeline_title: '',
      });
    }
  }
};

export const jdAppSharePanel = (shareInfo) => {
  const { url, title, content, channel } = shareInfo;
  JDShare.showShareDialog(
          url,
          title,
          content,
          'https://misc.360buyimg.com/business/house/static/img/sharelogo.png',
          channel,
        );
}

export const getEnv = () => {
  let _ua = navigator.userAgent.toLowerCase();
  if (!/mobile|android/.test(_ua)){
    return 'pc';
  } else {
    if(/micromessenger(\/[\d\.]+)*/.test(_ua)){
      return 'weixin';
    }else if(/qq\/(\/[\d\.]+)*/.test(_ua) || /qzone\//.test(_ua)){
      return 'qq';
    } else {
      return 'h5';
    }
  }
}

function shareTimeLine(options) {
  window.WeixinJSBridge.invoke('shareTimeline', options, (res) => { });
}
function shareFriend(options) {
  window.WeixinJSBridge.invoke('sendAppMessage', options, (res) => { });
}

// jdAppSharePanel里也有这个，share里也有这个，重复的，去掉一个吧
export const secondShasreInWX = (shareInfo={}) => {
  const { url='', title='', content='' } = shareInfo
  if (Platform.OS == 'web') {
    // 分享二次分享设置
    const weChatOptions = {
      appid: '', // 可以不设置 但必须存在这属性
      img_url: 'https://misc.360buyimg.com/business/house/static/img/sharelogo.png', // 分享图片的路径
      img_width: '120',
      img_height: '120',
      link: window.location.href ? window.location.href : url, // 分享的链接
      desc: content,
      title: title, // 分享的标题
    };
    const currentEnv = getEnv();
    weChatOptions.title = title;
    if (currentEnv === 'weixin' || currentEnv === 'qq') {
      try {
        if (!window.weChatOrMQReady && !window.WeixinJSBridge) {
          document.addEventListener('WeixinJSBridgeReady', () => {
            window.weChatOrMQReady = true;
            window.WeixinJSBridge.on('menu:share:appmessage', () => {
              shareFriend(weChatOptions);
            });
            window.WeixinJSBridge.on('menu:share:timeline', () => {
              shareTimeLine(weChatOptions);
            });
          }, false);
        } else {
          window.WeixinJSBridge.on('menu:share:appmessage', () => {
            shareFriend(weChatOptions);
          });
          window.WeixinJSBridge.on('menu:share:timeline', () => {
            shareTimeLine(weChatOptions);
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};

